import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5001/api/v1';

export default function PublicRecruiterVerify() {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!code) return;
    fetch(`${API_BASE}/recruiters/verify?code=${encodeURIComponent(code)}`)
      .then(r => r.json())
      .then(res => {
        if (res.verified) setData(res);
        else setError(res.error || 'Recruiter not found');
      })
      .catch(() => setError('Unable to verify. Please try again.'))
      .finally(() => setLoading(false));
  }, [code]);

  if (!code) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0fdf4', fontFamily: 'system-ui, sans-serif', padding: '20px' }}>
        <div style={{ background: '#fff', padding: '48px', borderRadius: '16px', boxShadow: '0 4px 24px rgba(0,0,0,0.08)', textAlign: 'center', maxWidth: '420px', width: '100%' }}>
          <div style={{ fontSize: '64px', marginBottom: '8px' }}>🔍</div>
          <h1 style={{ fontSize: '24px', color: '#166534', margin: '0 0 4px' }}>Verify a Recruiter</h1>
          <p style={{ color: '#64748b', margin: '0 0 24px', fontSize: '14px' }}>
            Enter the recruiter's referral code to verify they are registered with OUK
          </p>
          <form onSubmit={(e) => { e.preventDefault(); window.location.href = `/verify?code=${encodeURIComponent(e.target.code.value)}`; }}>
            <input
              name="code"
              type="text"
              placeholder="Enter referral code (e.g. 1234)"
              style={{ width: '100%', padding: '12px 16px', border: '1px solid #e2e8f0', borderRadius: '8px', fontSize: '14px', marginBottom: '12px', boxSizing: 'border-box' }}
              required
            />
            <button type="submit" className="btn btn-primary" style={{ width: '100%' }}>Verify</button>
          </form>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0fdf4', fontFamily: 'system-ui, sans-serif' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ width: 40, height: 40, border: '3px solid #e2e8f0', borderTop: '3px solid #166534', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto 16px' }} />
          <p style={{ color: '#64748b' }}>Verifying...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0fdf4', fontFamily: 'system-ui, sans-serif' }}>
        <div style={{ background: '#fff', padding: '48px', borderRadius: '16px', boxShadow: '0 4px 24px rgba(0,0,0,0.08)', textAlign: 'center', maxWidth: '420px' }}>
          <div style={{ fontSize: '64px', marginBottom: '16px' }}>❌</div>
          <h1 style={{ fontSize: '20px', color: '#dc2626', marginBottom: '8px' }}>Not Found</h1>
          <p style={{ color: '#64748b', margin: 0 }}>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0fdf4', fontFamily: 'system-ui, sans-serif', padding: '20px' }}>
      <div style={{ background: '#fff', padding: '48px', borderRadius: '16px', boxShadow: '0 4px 24px rgba(0,0,0,0.08)', textAlign: 'center', maxWidth: '480px', width: '100%' }}>
        <div style={{ fontSize: '64px', marginBottom: '8px' }}>✅</div>
        <h1 style={{ fontSize: '24px', color: '#166534', margin: '0 0 4px' }}>Verified Recruiter</h1>
        <p style={{ color: '#64748b', margin: '0 0 24px', fontSize: '14px' }}>
          This recruiter is registered with the Open University of Kenya (OUK)
        </p>

        <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: '24px' }}>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ fontSize: '12px', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Full Name</label>
            <p style={{ fontSize: '18px', fontWeight: 600, color: '#1e293b', margin: '4px 0' }}>{data.name}</p>
          </div>

          <div style={{ marginBottom: '16px' }}>
            <label style={{ fontSize: '12px', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Referral Code</label>
            <p style={{ fontSize: '16px', fontWeight: 700, color: '#037b90', margin: '4px 0', fontFamily: 'monospace' }}>{data.referral_code}</p>
          </div>

          <div style={{ marginBottom: '16px' }}>
            <label style={{ fontSize: '12px', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Email</label>
            <p style={{ fontSize: '16px', color: '#1e293b', margin: '4px 0' }}>{data.email}</p>
          </div>

          {data.mobile && (
            <div style={{ marginBottom: '16px' }}>
              <label style={{ fontSize: '12px', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Phone</label>
              <p style={{ fontSize: '16px', color: '#1e293b', margin: '4px 0' }}>{data.mobile}</p>
            </div>
          )}

          <div style={{ marginBottom: '16px' }}>
            <label style={{ fontSize: '12px', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Category</label>
            <p style={{ fontSize: '14px', color: '#475569', margin: '4px 0' }}>{data.category}</p>
          </div>
        </div>

        <div style={{ marginTop: '24px', padding: '16px', background: '#f0fdf4', borderRadius: '8px', border: '1px solid #bbf7d0' }}>
          <p style={{ fontSize: '13px', color: '#166534', margin: 0 }}>
            This information is provided by the Open University of Kenya (OUK) recruitment system to help you verify that this recruiter is genuine and authorized.
          </p>
        </div>
      </div>
    </div>
  );
}